import { render, staticRenderFns } from "./TuitionCollectionTable.vue?vue&type=template&id=44258da9&lang=true"
import script from "./TuitionCollectionTable.vue?vue&type=script&lang=js"
export * from "./TuitionCollectionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports